// Sidebar entries owned by the Service module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { servicePaths } from './paths'

export const serviceNav = {
    list: {
        title: 'services:sidebar_title',
        path: servicePaths.services,
        rsname: resources.services,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
